import {
  ACESFilmicToneMapping,
  AmbientLight,
  DirectionalLight,
  Group,
  PerspectiveCamera,
  SRGBColorSpace,
  Scene,
  WebGLRenderer,
} from 'three'

export type SharedOffscreen = {
  readonly canvas: HTMLCanvasElement
  readonly renderer: WebGLRenderer
  readonly scene: Scene
  readonly root: Group
  readonly camera: PerspectiveCamera
}

let _sharedOffscreen: SharedOffscreen | null = null

const getSharedOffscreen = (originalScene?: Scene): SharedOffscreen => {
  if (_sharedOffscreen) {
    if (originalScene && !_sharedOffscreen.scene.environment) {
      _sharedOffscreen.scene.environment = originalScene.environment ?? null
    }
    return _sharedOffscreen
  }

  const canvas = document.createElement('canvas')
  const renderer = new WebGLRenderer({ canvas, antialias: true, alpha: true, preserveDrawingBuffer: true })
  renderer.outputColorSpace = SRGBColorSpace
  renderer.toneMapping = ACESFilmicToneMapping
  renderer.toneMappingExposure = 1.0
  renderer.autoClearColor = false
  renderer.autoClear = false
  renderer.setClearColor(0x000000, 0)

  const scene = new Scene()
  const root = new Group()
  scene.add(root)
  const camera = new PerspectiveCamera(35, 1, 0.1, 1000)

  const key = new DirectionalLight(0xffffff, 3)
  key.position.set(2, 3, 4)
  const fill = new DirectionalLight(0xffffff, 1.5)
  fill.position.set(-2, 1, 1)
  const ambient = new AmbientLight(0xffffff, 1)
  scene.add(key, fill, ambient)

  scene.environment = originalScene?.environment ?? null
  _sharedOffscreen = { canvas, renderer, scene, root, camera }
  return _sharedOffscreen
}

export const useSharedOffscreen = (originalScene?: Scene) => {
  return {
    sharedOffscreen: getSharedOffscreen(originalScene),
  } as const
}
